import React, { Component} from 'react';
import Select from 'react-select';
import { withAuthorization } from '../Session';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

import {MENTOR_AVAILABILITY_OPTIONS, MENTOR_HACKATHON_EXP_OPTIONS, LEAD_MENTOR_OPTIONS} from '../../constants/registration';


const MentorRegPage = () => (
  <div id="page-reg-mentor" className="reg-page">
    <MentorRegForm />
  </div>
);

const INITIAL_STATE = {
  availability: '', hackathon_experience: '', want_lead_mentor: '', additional_skills:'',
  pref_area: {ideation:false, prototype:false, presentation:false, team: false}
};

class MentorRegFormBase extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  componentDidMount(){
    let uid = this.props.firebase.auth.currentUser.uid;
    this.props.firebase.user(uid).on("value", snapshot => {
      const userObject = snapshot.val();
      //console.log("MENTOR USER OBJ: ", userObject);
      if (userObject && userObject.mentor) {
        let {availability, hackathon_experience, want_lead_mentor, pref_area, additional_skills} = userObject.mentor;
        this.setState({availability, hackathon_experience, want_lead_mentor, additional_skills,
          pref_area: pref_area||{ideation:false, prototype:false, presentation:false, team: false}});
      }
    }, function (errorObject) {
      console.log("The read failed: " + errorObject.code);
    });
  }

  componentWillUnmount(){
    if(this.props.firebase.auth.currentUser && this.props.firebase.auth.currentUser.uid){
      //console.log("MENTOR UNMOUNT");
      this.props.firebase.user(this.props.firebase.auth.currentUser.uid).off();
    }
  }


  onSubmit = event => {
    const {availability, hackathon_experience, want_lead_mentor, pref_area, additional_skills} = this.state;
    this.saveToDB(availability, hackathon_experience, want_lead_mentor, pref_area, additional_skills);
    // go to next page
    this.props.history.push(ROUTES.REG_DONE);

    event.preventDefault();
  }

  saveToDB (availability = '', hackathon_experience = '', want_lead_mentor = '', pref_area= {}, additional_skills=''){
    let mentor_desc = { availability, hackathon_experience, want_lead_mentor, pref_area, additional_skills,
      lastUpdated: Date.now() }
    //update to database
    let uid = this.props.firebase.auth.currentUser.uid
    this.props.firebase.user(uid).update({mentor: mentor_desc});
  }


  onBack = event => {
    this.props.history.push(ROUTES.REG_HOME)
  }
  
  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  onSelectChange = (selectedOption, action) =>{
    this.setState({ [action.name]: selectedOption });
  }
  onMentorPrefArea = event => {
    this.setState({ pref_area: { ...this.state.pref_area, [event.target.name]: !this.state.pref_area[event.target.name]} });
  }
  
  render() {
    const {availability, hackathon_experience, want_lead_mentor, pref_area, additional_skills,
      error} = this.state;

    const isInvalid = availability === '' || hackathon_experience === '' || pref_area.size === 0 ;

    return (
      <div className="bound-box">
        <h1>Ready to mentor?</h1>
        <p>Section 2 of 2</p>
        <form onSubmit={this.onSubmit}>
          <Select name="availability" value={availability} onChange={this.onSelectChange} options={MENTOR_AVAILABILITY_OPTIONS} placeholder="What is your availability between 20-22nd Nov?*" />
          <br /><br />
          <Select name="hackathon_experience" value={hackathon_experience} onChange={this.onSelectChange} options={MENTOR_HACKATHON_EXP_OPTIONS} placeholder="What is your hackathon experience?*" />
          <br /><br />
          <p>Which area(s) do you want to mentor teams in?* <br/><br/>
            <input type="checkbox" id="mpref_area_ideation" name="ideation" value="IDEATION" checked={(pref_area.ideation)} onChange={this.onMentorPrefArea}/>
            <label htmlFor="mpref_area_ideation"> <b>Ideation:</b> Assisting in brainstorming solutions to challenges</label>
            <br/>
            <input type="checkbox" id="mpref_area_prototype" name="prototype" value="PROTOTYPE" checked={(pref_area.prototype)} onChange={this.onMentorPrefArea}/>
            <label htmlFor="mpref_area_prototype"> <b>Prototyping:</b> Troubleshoot algorithms and test databases</label>
            <br/>
            <input type="checkbox" id="mpref_area_presentation"name="presentation" value="PRESENTATION" checked={(pref_area.presentation)} onChange={this.onMentorPrefArea}/>
            <label htmlFor="mpref_area_presentation"> <b>Presentation and Pitching:</b> Help teams communicate their project solutions</label>
            <br/>
            <input type="checkbox" id="mpref_area_team" name="team" value="TEAM" checked={(pref_area.team)} onChange={this.onMentorPrefArea}/>
            <label htmlFor="mpref_area_team"> <b>Team Management:</b> Helping teams make best use of their members for challenge</label>
          </p><br />
          
          <Select id="want_lead_mentor" name="want_lead_mentor" value={want_lead_mentor} onChange={this.onSelectChange} options={LEAD_MENTOR_OPTIONS} placeholder="Are you interested in providing support to other mentors?*"/>
          <br />
          
          <textarea name="additional_skills" value={additional_skills} onChange={this.onChange} maxLength="300" rows="3"
            placeholder="Are there any other skills or achievements you would like to mention? (300 char limit)"/>
          <br />
          
          <button type="button" onClick={this.onBack}>Back</button>
          <button disabled={isInvalid} type="submit">Submit</button>
          {error && <p>{error.message}</p>}
        </form>
      </div>
    );
  }

}




const condition = authUser => !!authUser;


const MentorRegForm = compose(
  withRouter,
  withFirebase,
)(MentorRegFormBase);

export default withAuthorization(condition)(MentorRegPage);

export { MentorRegForm };